<template>
  <div class="container-result">
    <div class="result-content">
      <h3 class="text-center mb-4">Сорил{{ levelId }} үр дүн</h3>
      <div class="my-4 shadow-lg">
        <vue-ellipse-progress v-bind="options" :progress="getProcent">
          <span slot="legend-value">%</span>
          <div class="legend" slot="legend-caption">
            <span class="get-score">
              Авсан оноо <a>{{ getPoint }}</a></span
            >
            <span class="total-score">/{{ totalPoint }}<a> нийт оноо</a></span>

            <div class="star-container">
              <div v-for="(i, index) in 3" :key="index">
                <b-icon
                  :class="{
                    'top-star': index === 1,
                    one: rating === 1 && index === 0,
                    two: rating === 2 && index < 2,
                    three: rating === 3 && index < 3,
                  }"
                  icon="star-fill"
                ></b-icon>
              </div>
            </div>
          </div>
        </vue-ellipse-progress>
      </div>

      <table class="table mx-auto result-table">
        <tr class="title">
          <th>Бодлогын дугаар:</th>
          <th>Үр дүн:</th>
          <th>Оноо:</th>
        </tr>
        <tr v-for="(item, i) in chosenList" :key="i">
          <td>{{ i + 1 }}</td>
          <td>
            <div v-if="result[item.qid] === 'success'">
              <span class="success">&#10003;</span>
            </div>
            <div v-if="result[item.qid] === 'wrong'">
              <span class="wrong">&#10005;</span>
            </div>
            <div v-if="result[item.qid] === 'nofill' || pairs[i].qid === null">
              -
            </div>
          </td>
          <td>
            <div v-if="result[item.qid] === 'success'">
              {{ item.score }}
            </div>
            <div v-if="result[item.qid] === 'wrong'">-1</div>
            <div v-if="result[item.qid] === 'nofill' || pairs[i].qid === null">
              0
            </div>
          </td>
        </tr>
      </table>

      <p class="text-center mt-4">
        <b-button :to="{name: 'LevelStage'}" variant="success">Дасгалаа үргэлжүүлэх</b-button>
      </p>

    </div>
  </div>
</template>

<script>
import OwnerService from "../api-services/owner.service.js";

export default {
  props: ["chosenList"],

  data: () => {
    return {
      rating: null,
      options: {
        color: "#22b353",
        size: 350,
        "empty-color": "#fff",
        "line-mode": "out",
        thickness: 8,
        "font-size": "3.5rem",
        "font-color": "#00000",
        "legend-class": "legend",
      },
      categoryId: null,
      angiId: null,
      bagtsId: null,
      levelId: null,
      totalPoint: 36,
      startPoint: 14,
      getProcent: null,
      getPoint: null,

      result: [],

      pairs: [
        { qid: null, aid: null },
        { qid: null, aid: null },
        { qid: null, aid: null },
        { qid: null, aid: null },
        { qid: null, aid: null },
        { qid: null, aid: null },
        { qid: null, aid: null },
        { qid: null, aid: null },
        { qid: null, aid: null },
      ],
    };
  },
  methods: {
    async getCheck() {
      try {
        const resp = await OwnerService.sorilCheck({
          angi: this.angiId,
          bagts: this.bagtsId,
          sorilNo: this.levelId,
          pairs: this.pairs,
        });

        this.result = JSON.parse(JSON.stringify(resp.data));
        this.getPoint = 0;
        this.totalPoint = 0;

        this.chosenList.forEach((element) => {
          this.totalPoint += element.score;
          if (this.result[element.qid] === "success") {
            this.getPoint += element.score;
          } else if (this.result[element.qid] === "wrong") {
            this.getPoint -= 1;
          }
        });

        this.getProcent = Math.round((this.getPoint / this.totalPoint) * 100);

        if (this.getProcent > 90) {
          this.rating = 3;
        } else if (this.getProcent > 60) {
          this.rating = 2;
        } else if (this.getProcent > 30) {
          this.rating = 1;
        } else if (this.getProcent < 30) {
          this.rating = 0;
        }
      } catch (ex) {
        console.log(ex);
      }
    },
  },

  async mounted() {
    this.categoryId = localStorage.getItem("category");
    this.angiId = localStorage.getItem("angi");
    this.bagtsId = localStorage.getItem("bagts");
    this.levelId = localStorage.getItem("level");

    var i = 0;
    this.pairs.forEach((element) => {
      element.qid = this.chosenList[i].qid;
      element.aid = this.chosenList[i].aid;
      i++;
    });

    await this.getCheck();
  },
};
</script>

<style scoped>
.container-result {
  padding: 80px 0px 30px 0px;
  font-family: "Roboto", sans-serif;
}
.result-content {
  padding: 25px 0px 40px 0px;
  background: #fff;
  max-width: 700px;
  margin: 0 auto 0 auto;
  border: 1px solid #b6887b;
}
.result-content h3 {
  text-align: start;
  color: #52b700;
}
.success {
  color: #52b700;
}
.wrong {
  color: red;
}
.nofill {
  color: red;
}
.star-container {
  display: flex;
  justify-content: space-around;
  font-size: 1.7em;
  color: #e6e9f0;
  stroke: #f9850c;
  max-width: 90px;
  margin: 0 auto 0 auto;
}

.one {
  color: red;
}
.three {
  color: red;
}
.two {
  color: red;
}
.legend {
  color: #000000;
}
.legend .get-score {
  font-size: 1.4em;
  color: #52b700;
}
.legend a {
  font-size: 2.4rem;
  color: #52b700;
}
.legend a:hover {
  color: #52b700;
}
.legend .total-score {
  font-size: 1.4rem;
}
.legend .total-score a {
  font-size: 1rem;
  color: #000000;
}

.ep-container {
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.shadow-lg {
  position: relative;
  min-height: 335px;
  max-width: 335px;
  border-radius: 50%;
  margin: 0 auto 0 auto;
  background: #fff;
}

.explain {
  display: flex;
  float: right;
  padding-right: 60px;
}

.result-table {
  max-width: 80%;
  margin: 0 auto;
  border: 3px solid seagreen;
}
</style>
